import { ReactNode, createContext, useContext, useState } from 'react';
import { ERRORS } from '@/common/constants/errors';
import { TInsurancePlanSimulation } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';

type InsuranceContextType = {
  simulation: TInsurancePlanSimulation;
  setSimulation: (simulation: TInsurancePlanSimulation) => void;
  resetSimulation: () => void;
};

const initialSimulation: TInsurancePlanSimulation = {
  persons: [],
  totalCost: MoneyUtils.defaultMoney,
  metadata: {
    exemptionAmount: MoneyUtils.defaultMoney,
  },
  savingsAmount: MoneyUtils.defaultMoney,
  holderPaymentMethodsAllowed: [],
};

const InsuranceContext = createContext<InsuranceContextType | undefined>(
  undefined
);

export const InsuranceProvider = ({ children }: { children: ReactNode }) => {
  const [simulation, setSimulation] =
    useState<TInsurancePlanSimulation>(initialSimulation);

  const resetSimulation = () => {
    setSimulation(initialSimulation);
  };

  return (
    <InsuranceContext.Provider
      value={{ simulation, setSimulation, resetSimulation }}
    >
      {children}
    </InsuranceContext.Provider>
  );
};

export const useInsuranceContext = () => {
  const context = useContext(InsuranceContext);
  if (!context) {
    throw new Error(ERRORS.CONTEXT_VALUE_REQUIRED);
  }
  return context;
};
